import api from "../../axiosConfig";

export const addConsultData = async (formData) => {
    const token= sessionStorage.getItem('token');
    try {

      const response = await api.post(`/consultant/consultdata/${formData?.id}`, formData);
      const resData = response?.data;
      console.log('Response data:', resData);
  
      if (resData?.success_type === 'success' || resData?.message_type === 'success') {
        return { success: true, data: resData };
      } else {
        return { success: false, error: resData.message };
      }
    } catch (err) {
      throw new Error(err.response?.data?.message || 'Login error');
    }
  };


export const getPreconsultData = async (doctorID) => {
  const token = sessionStorage.getItem('token');

  try {
    const response = await api.get(`/consultant/preconsultdata/${doctorID}`);

    const resData = response?.data;
    console.log('Response data:', resData);

    if (resData?.success_type === 'success' || resData?.message_type === 'success') {
      return { success: true, data: resData?.data };
    } else {
      return { success: false, error: resData.message };
    }
  } catch (err) {
    throw new Error(err.response?.data?.message || 'Error fetching preconsult data');
  }
};

export const getCaseSheetData = async (patientId) => {
  const token = sessionStorage.getItem('token');

  try {
    const response = await api.get(`/consultant/casesheet/${patientId}`);

    const resData = response?.data;
    console.log('Response data:', resData);

    if (resData?.success_type === 'success' || resData?.message_type === 'success') {
      return { success: true, data: resData?.data };
    } else {
      return { success: false, error: resData.message };
    }
  } catch (err) {
    throw new Error(err.response?.data?.message || 'Error fetching casesheet data');
  }
};

export const getConsultantMedicinesData = async (appointmentId) => {
  const token = sessionStorage.getItem('token');

  try
  {
    const response = await api.get(`/consultant/medicines/${appointmentId}`);

    const resData = response?.data;
    // console.log('Response consultant medicines data:', resData);s

    if (resData?.success_type === 'success' || resData?.message_type === 'success')
    {
      return { success: true, data: resData?.data };
    }
    else
    {
      return { success: false, error: resData.message };
    }
  }
  catch (err)
  {
    throw new Error(err.response?.data?.message || 'Error fetching casesheet data');
  }
};

// export const updateDiagnoses = async (id, formData) => {
//   const token = sessionStorage.getItem('token');

//   // Append required format values
//   const payload = {
//     ...formData,
//     id: parseInt(id),
//     _method: 'put', // Required for Laravel-style method spoofing
//   };
//   console.log('Payload for update:', payload);

//   try {
//     const response = await api.post(`/diagnoses/update-diagnoses/${id}`, payload
//     );

//     const resData = response?.data;
//     console.log('Update receptionist response:', resData);

//     if (resData?.success_type === 'success') {
//       return { success: true, data: resData };
//     } else {
//       return { success: false, error: resData.message };
//     }
//   } catch (err) {
//     throw new Error(err.response?.data?.message || 'Error updating receptionist');
//   }
// };